import React, {useEffect, useState} from 'react';
import DG_Form from "../../../../custom/data-entry/form";
import DG_Submit from "../../../../common/button/Submit";
import DG_Button from "../../../../common/button/Button";
import {Col, Collapse, Form, Input, Row, Select} from "antd";
import {useTranslation} from "react-i18next";
import {
    addCompensatoryConfigApi,
    loadCompensatoryConfigApi
} from "../../../../api/setting/timekeeping/compensatory-leave";
import {Option} from "antd/es/mentions";
import {useDispatch} from "react-redux";
import {setHeader} from "../../../../redux/actions/layout/interaction/action";
import DG_FormItem_LabelDetail from "../../../../custom/data-entry/form/Item/LabelDetail";
import DG_Cancel from "../../../../common/button/Cancel";
import Header from "../../application/general/components/common/Header";
import SwitchCustom from "../../application/general/components/common/SwitchCustom";

const CompensatoryLeaveSettingForm = props => {
    const {t} = useTranslation();
    const [form] = Form.useForm();
    const [show, setShow] = useState();
    const [showSub, setShowSub] = useState();
    const {Panel} = Collapse;

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(setHeader(t("timeKeeping-setting.compensation-setting.compensation-header"), null))
    }, [])

    useEffect(() => {
        loadCompensatoryConfigApi().then(response => {
            setValue(response)
        })
    }, [])

    function setValue(response) {

        setShow(response.compensatoryCreateFlag);
        setShowSub(response.advancePaymentFlag);

        form.setFieldsValue(
            {
                compensatoryCreateFlag: response.compensatoryCreateFlag,
                conversionRate: response.conversionRate === 0 ? undefined : response.conversionRate,
                expiredTime: response.expiredTime,
                advancePaymentFlag: response.advancePaymentFlag,
                compensatoryHour: response.compensatoryHour
            }
        )
    }

    const onFinish = (values) => {
        values = {
            compensatoryCreateFlag: values.compensatoryCreateFlag,
            conversionRate: values.conversionRate === undefined ? null : values.conversionRate,
            expiredTime: values.expiredTime === undefined ? "no-expire" : values.expiredTime,
            advancePaymentFlag: values.advancePaymentFlag === undefined ? null : values.advancePaymentFlag,
            compensatoryHour: values.compensatoryHour === undefined ? null : values.compensatoryHour
        }

        addCompensatoryConfigApi(values);
    }
    return (
        <>
            <DG_Form
                form={form}
                mode="update"
                onFinish={onFinish}
                layout="horizontal"
                success={false}
                className={"form-hrmConfig  rounded-tl-[8px] rounded-tr-[8px]"}
                style={{
                    background: "#fff",
                    borderRight: "1px solid #EAECF0",
                    borderLeft: "1px solid #EAECF0",
                    borderTop: "1px solid #EAECF0",
                    height: "100%",
                    overflow: "auto",
                }}
            >
                <DG_Button title={t("tnp.components.salary.text203")}>

                    <DG_Cancel/>
                    <DG_Submit mode={"update"}/>

                </DG_Button>

                <Row>
                    <Col xs={24} sm={24} xl={18}>
                        <Collapse
                            defaultActiveKey={['1']}
                            expandIconPosition={'end'}
                            className={"setting-hrmConfig"}
                            bordered={false}
                        >
                            <Panel key="1"
                                   header={
                                       <Header>{t("timeKeeping-setting.compensation-setting.compensation-header")}</Header>}>


                                <DG_FormItem_LabelDetail
                                    label={t("timeKeeping-setting.compensation-setting.allow-compensation")}
                                    labelDetail={t("timeKeeping-setting.compensation-setting.allow-compensation-detail")}
                                    valuePropName={"checked"}
                                    name={"compensatoryCreateFlag"}
                                    initialValue={"all"}
                                >
                                    <SwitchCustom onChange={checked => setShow(checked)}/>
                                </DG_FormItem_LabelDetail>
                                {show ? <div style={{marginLeft: 20}}>
                                    <DG_FormItem_LabelDetail
                                        label={t("timeKeeping-setting.compensation-setting.conversionRate")}
                                        labelDetail={t("timeKeeping-setting.compensation-setting.conversionRate-detail")}
                                        name={"conversionRate"}
                                    >
                                        <Input/>
                                    </DG_FormItem_LabelDetail>
                                    <DG_FormItem_LabelDetail
                                        label={t("timeKeeping-setting.compensation-setting.timeExpire")}
                                        labelDetail={t("timeKeeping-setting.compensation-setting.timeExpireDetail")}
                                        name={"expiredTime"}
                                        initialValue={"no-expire"}
                                    >
                                        <Select
                                            defaultValue={"no-expire"}
                                        >
                                            <Option
                                                value="no-expire">{t("timeKeeping-setting.compensation-setting.timeExpireForm.doesNotExpire")}</Option>
                                            <Option
                                                value="expire-one-month">{t("timeKeeping-setting.compensation-setting.timeExpireForm.expiresInMonth")}</Option>
                                            <Option
                                                value="one-month">{t("timeKeeping-setting.compensation-setting.timeExpireForm.1Month")}</Option>
                                            <Option
                                                value="three-month">{t("timeKeeping-setting.compensation-setting.timeExpireForm.3Month")}</Option>
                                            <Option
                                                value="six-month">{t("timeKeeping-setting.compensation-setting.timeExpireForm.6Month")}</Option>
                                            <Option
                                                value="twelve-month">{t("timeKeeping-setting.compensation-setting.timeExpireForm.12Month")}</Option>
                                        </Select>
                                    </DG_FormItem_LabelDetail>
                                    <DG_FormItem_LabelDetail
                                        label={t("timeKeeping-setting.compensation-setting.compensatory-leave")}
                                        labelDetail={t("timeKeeping-setting.compensation-setting.compensatory-leave-detail")}
                                        valuePropName={"checked"}
                                        name={"advancePaymentFlag"}
                                    >
                                        <SwitchCustom onChange={checked => setShowSub(checked)}/>
                                    </DG_FormItem_LabelDetail>
                                    {showSub ? <div style={{marginLeft: 20}}>
                                        <DG_FormItem_LabelDetail
                                            label={t("timeKeeping-setting.compensation-setting.compensatory-leave-maxtime")}
                                            labelDetail={t("timeKeeping-setting.compensation-setting.compensatory-leave-maxtime-detail")}
                                            name={"compensatoryHour"}
                                        >
                                            <Input
                                                placeholder={t("timeKeeping-setting.compensation-setting.compensatory-leave-maxtime-form")}/>
                                        </DG_FormItem_LabelDetail>
                                    </div> : <></>}
                                </div> : <> </>}
                            </Panel>
                        </Collapse>
                    </Col>
                </Row>
            </DG_Form>
        </>
    );
};

CompensatoryLeaveSettingForm.propTypes = {};

export default CompensatoryLeaveSettingForm;
